require("slick-carousel");

$(document).ready(() => {
  $("#one-el-slider").slick({
    centerMode: true,
    arrows: true,
    slidesToShow: 1
  });
  $("#gallery").slick({
    centerMode: true,
    centerPadding: "100px",
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "25px",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $("#brands").slick({
    dots: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $(".featured").slick({
    centerMode: false,
    infinite: true,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "25px",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
